import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { FormIngresoService } from '../../../services/forms/form-ingreso.service'

@Component({
  selector: 'app-dialog-ingreso-insumo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dialog-ingreso-insumo.component.html',
  styleUrls: ['./dialog-ingreso-insumo.component.scss']
})
export class DialogIngresoInsumoComponent implements OnInit {
  ingresoForm
  constructor (
    private readonly formIngresoService: FormIngresoService,
    public readonly dialogIngresoInsumoComponentRef: MatDialogRef<DialogIngresoInsumoComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string
      cantidad: number
      costo: number
    }
  ) {
    this.ingresoForm = this.formIngresoService.getIngresoForm()
  }

  ngOnInit (): void {
    this.ingresoForm
      .get(['insumoAlmacen', 'cantidad'])
      ?.setValue(this.data.cantidad)
    this.ingresoForm.get(['insumoAlmacen', 'costo'])?.setValue(this.data.costo)
  }

  updateInsumo () {
    this.dialogIngresoInsumoComponentRef.close({
      cantidad: this.ingresoForm.value.insumoAlmacen?.cantidad,
      costo: this.ingresoForm.value.insumoAlmacen?.costo
    })
  }
}
